'use client';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import data from '../../../l-data/testimonials.json';

function Testimonials() {
  const swiperOptions = {
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    breakpoints: {
      768: { slidesPerView: 2, spaceBetween: 30 },
      1200: { slidesPerView: 3, spaceBetween: 30 },
    },
  };
  return (
    <section className="testimonials section-padding sub-bg pt-0" style={{marginBottom: '-200px'}}>
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">Community Voices</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              What people <span className="fw-200">say about us</span>
            </h2>
          </div>
        </div>
        <div className="testim-swiper">
          <Swiper
            id="content-carousel-container-unq-testim"
            className="swiper-container"
            data-swiper="container"
            {...swiperOptions}
          >
            {data?.map((item, i) => (
              <SwiperSlide key={i}>
                <div className="item main-bg radius-15">
                  <div className="content p-40">
                    <div className="d-flex align-items-center mb-30">
                      <div>
                        <span className="tag sub-title mb-0">{item.tag}</span>
                      </div>
                      <div className="ml-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" viewBox="0 0 256.721 208.227" className="qout-svg opacity-3">
                          <path d="M-23.723-530.169v97.327H-121.05v-68.7q0-40.076,13.359-73.472T-62.845-639.9l36.259,28.625Q-63.8-570.244-68.57-530.169Zm158.395,0v97.327H37.345v-68.7q0-40.076,13.359-73.472T95.55-639.9l36.259,28.625Q94.6-570.244,89.825-530.169Z" transform="translate(121.55 640.568)" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5"></path>
                        </svg>
                      </div>
                    </div>
                    <div className="text mb-40">
                      <p className="fz-20">{item.desc}</p>
                    </div>
                    <div className="info d-flex align-items-center">
                      <div style={{width: '55px', height: '55px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0}}>
                        <img src={item.img} alt={item.name} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                      </div>
                      <div className="ml-30">
                        <h6>{item.name}</h6>
                        <span className="sub-title main-color">{item.subName}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
